import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

function useSwitchPage() {
  const [currentURL, setCurrentURL] = useState('/shop')
  const location = useLocation()
  const currentPath = location.pathname

  useEffect(() => {
    if (currentPath === '/shop') {
      setCurrentURL('/')
    } else {
      setCurrentURL('/shop')
    }
  }, [currentPath])

  return currentURL
}

export default useSwitchPage
